import { render, staticRenderFns } from "./CreateGuarantee.vue?vue&type=template&id=0036d0e8"
import script from "./CreateGuarantee.vue?vue&type=script&lang=js"
export * from "./CreateGuarantee.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports